import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all clients
export async function getAllClients(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/clients?page=${page}`);
    return response;
  } catch (error) {
    console.error("Error fetching clients:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new client
export async function createClients(clientData) {
  try {
    const response = await post(`${API_URL}/crud/clients`, clientData);
    return response;
  } catch (error) {
    console.error("Error creating client:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single client by ID
export async function getClientsById(clientId) {
  try {
    const response = await axios.get(`${API_URL}/crud/clients/${clientId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching client with ID ${clientId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to update an existing client
export async function updateClients(clientId, clientData) {
  try {
    const response = await put(
      `${API_URL}/crud/clients/${clientId}`,
      clientData
    );
    return response;
  } catch (error) {
    console.error(`Error updating client with ID ${clientId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to delete a client
export async function deleteClients(clientId) {
  try {
    const response = await del(`${API_URL}/crud/clients/${clientId}`);
    return response;
  } catch (error) {
    console.error(`Error deleting client with ID ${clientId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
